// Pour les librairies qui utilisent global

if (typeof (window as any).global === 'undefined') {
  (window as any).global = window;
}

export {};
